<template>
  <div class="flex relative pt10 search-block">
    <input
      type="search"
      id="search"
      v-model="search"
      @keyup.enter="filterPartners"
      @input="inputSearch"
      :placeholder="$t('Search partners')"
      :validations="[
        {
          condition: $v.search.$error && !$v.search.required,
          text: $t('Field is required')
        }
      ]"
    >
    <div class="close-icon-row" v-show="showClose">
      <i
        class="material-icons pointer cl-accent close-icon"
        data-testid="closeSearchPanel"
        @click="clearInput"
      >
        close
      </i>
    </div>
    <div class="icon-search" @click="filterPartners"><i class="material-icons base-icon search-icon">search</i></div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import debounce from 'lodash-es/debounce'
import config from 'config';
import {mapGetters} from "vuex";

export default {
  name: "SearchPartner",
  data() {
    return {
      search: '',
      inputSearch: ''
    }
  },
  validations: {
    search: {
      required
    }
  },
  created () {
    this.inputSearch = debounce(this.filterPartners, config.partners.search_delay)
  },
  methods: {
    filterPartners() {
      let locationCode = this.$store.getters['locations/getActiveLocation'].code
      !this.$v.$invalid
        ?this.$store.dispatch('partners/filterPartner', {filter: this.search.toLowerCase(), categoryId: this.getActivePartnersCategory.entity_id , locationCode})
        :this.$store.dispatch('partners/clearFilterPartners')
    },
    clearInput() {
      this.search = ''
      this.$store.dispatch('partners/clearFilterPartners')
    }
  },
  computed: {
    ...mapGetters({
      getActivePartnersCategory: 'partner_categories/getActivePartnersCategory'
    }),
    showClose () {
      return this.search && !this.$v.$invalid
    }
  },
  beforeDestroy () {
    this.clearInput()
  }
}
</script>

<style lang="scss" scoped>
  .close-icon-row {
    position: absolute;
    top: 19px;
    right: 45px;
  }
  .search-block {
    @media (max-width: 425px) {
      width: 90%;
    }
  }
  #search {
    width: 355px;
    border-radius: 5px;
    background-color: #fff;
    border: none;
    appearance: none;
    padding-top: 0;
    padding-bottom: 0;
    box-sizing: unset;
    outline: none;
    height: 42px;
    padding-left: 15px;
    font-size: 14px;
    @media (max-width: 425px) {
      width: 100%;
    }
  }
  .icon-search {
    background: #11bb2e;
    border-radius: 5px;
    position: absolute;
    right: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    cursor: pointer;
    color: #fff;
    i {
      display: block;
      padding: 9px;
      width: 24px;
      height: 24px;
      box-sizing: content-box;
    }
  }
</style>
